import Swiper from 'swiper/bundle';

export const initSliderTestimonials = () => {
    const width = 680;
    const userInnerWidth = window.innerWidth;
    const trigger = document.querySelector('[data-testimonials="mobile-slider"]');

    if (trigger && userInnerWidth > width) return;

    new Swiper('[data-testimonials]', {
        loop: true,
        centeredSlides: true,
        grabCursor: true,
        slidesPerView: 1,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
        },
    });
};
